/**
 * Kanama Ride — client helpers
 */
import api from "./api";

export const NDJAMENA_CENTER = { lat: 12.1348, lng: 15.0557 };

export const VEHICLES = {
  taxi: {
    key: "taxi",
    label: "Taxi",
    icon: "Car",
    color: "#C8A04D",
    description: "Voiture standard 4 places",
  },
  moto: {
    key: "moto",
    label: "Moto-taxi",
    icon: "Bike",
    color: "#B25E3F",
    description: "Plus rapide, idéal pour 1 personne",
  },
};

export async function estimate({ pickup, destination, vehicle_type }) {
  const { data } = await api.post("/ride/estimate", { pickup, destination, vehicle_type });
  return data;
}

export async function requestRide({ pickup, destination, vehicle_type }) {
  const { data } = await api.post("/ride/request", { pickup, destination, vehicle_type });
  return data;
}

export async function getRide(rideId) {
  const { data } = await api.get(`/ride/${rideId}`);
  return data;
}

export async function cancelRide(rideId) {
  const { data } = await api.post(`/ride/${rideId}/cancel`);
  return data;
}

export async function rateRide(rideId, rating, comment = "") {
  const { data } = await api.post(`/ride/${rideId}/rate`, { rating, comment });
  return data;
}

export async function getMyHistory() {
  const { data } = await api.get("/ride/me/history");
  return data;
}

export async function getMyDriver() {
  const { data } = await api.get("/ride/driver/me");
  return data;
}

export async function driverSignup(payload) {
  const { data } = await api.post("/ride/driver/signup", payload);
  return data;
}

export async function setDriverOnline({ online, lat, lng }) {
  const { data } = await api.put("/ride/driver/online", { online, lat, lng });
  return data;
}

export async function getDriverInbox() {
  const { data } = await api.get("/ride/driver/inbox");
  return data;
}

export async function getDriverEarnings() {
  const { data } = await api.get("/ride/driver/earnings");
  return data;
}

export async function driverAccept(rideId) {
  const { data } = await api.post(`/ride/${rideId}/accept`);
  return data;
}

export async function driverReject(rideId) {
  const { data } = await api.post(`/ride/${rideId}/reject`);
  return data;
}

export async function driverStart(rideId) {
  const { data } = await api.post(`/ride/${rideId}/start`);
  return data;
}

export async function driverComplete(rideId) {
  const { data } = await api.post(`/ride/${rideId}/complete`);
  return data;
}

// ===== Promo codes =====
export async function applyPromoCode(code, baseAmountXaf) {
  const { data } = await api.post("/ride/promo/apply", {
    code: code.trim().toUpperCase(),
    base_amount_xaf: Math.round(baseAmountXaf),
  });
  return data;
}

export async function getPricing() {
  const { data } = await api.get("/ride/pricing");
  return data;
}

// ===== Payments (Airtel / Moov / Cash) =====
export async function initiatePayment({ provider, msisdn, pickup, destination, vehicle_type }) {
  const { data } = await api.post("/ride/payments/initiate", {
    provider, msisdn, pickup, destination, vehicle_type,
  });
  return data;
}

export async function confirmSandboxOTP(paymentId, otp) {
  const { data } = await api.post(`/ride/payments/${paymentId}/confirm-sandbox`, { otp });
  return data;
}

export async function getPayment(paymentId) {
  const { data } = await api.get(`/ride/payments/${paymentId}`);
  return data;
}

export async function adminListPaymentCredentials() {
  const { data } = await api.get("/ride/admin/payment-credentials");
  return data.credentials;
}

export async function adminSavePaymentCredentials(payload) {
  const { data } = await api.put("/ride/admin/payment-credentials", payload);
  return data;
}

// File -> base64 data URI (capped at ~5 MB)
export function fileToDataUri(file) {
  return new Promise((resolve, reject) => {
    if (file.size > 5_000_000) {
      reject(new Error("Fichier trop volumineux (max 5 MB)"));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

export function formatFcfa(value) {
  if (value === null || value === undefined) return "—";
  return `${Math.round(value).toLocaleString("fr-FR")} FCFA`;
}

export function formatDuration(min) {
  if (min < 1) return "moins d'1 min";
  if (min < 60) return `${Math.round(min)} min`;
  const h = Math.floor(min / 60);
  const m = Math.round(min % 60);
  return `${h}h${m.toString().padStart(2, "0")}`;
}

export const RIDE_STATUS_LABELS = {
  requested: { label: "Recherche d'un chauffeur…", tone: "amber" },
  accepted: { label: "Chauffeur en route", tone: "blue" },
  in_progress: { label: "Course en cours", tone: "green" },
  completed: { label: "Course terminée", tone: "neutral" },
  cancelled: { label: "Course annulée", tone: "red" },
  rejected: { label: "Aucun chauffeur disponible", tone: "red" },
};
